import List from 'myNumber/auditLogs/List'
import Show from 'myNumber/auditLogs/Show'

export default {
  List,
  Show,
}
